// Stage 7A C2 — a small segmented-button radio group, reused across the compose
// sections (Goal, budget level, destination type C3, placement mode C6, etc.).
// Local to the metaAds module; no Radix radio primitive exists in ui/.

export type RadioOption<T extends string> = {
  value: T;
  label: string;
  description?: string;
};

export function RadioGroup<T extends string>({
  label,
  value,
  options,
  onChange,
  ariaLabel,
}: {
  label?: string;
  value: T;
  options: RadioOption<T>[];
  onChange: (value: T) => void;
  ariaLabel?: string;
}) {
  return (
    <div>
      {label && <div className="mb-1.5 text-sm font-medium text-slate-700">{label}</div>}
      <div role="radiogroup" aria-label={ariaLabel ?? label} className="inline-flex flex-wrap gap-2">
        {options.map((opt) => {
          const selected = opt.value === value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(opt.value)}
              className={[
                'rounded-md border px-3 py-2 text-left text-sm transition-colors',
                selected
                  ? 'border-kyck-500 bg-kyck-50 text-kyck-900 ring-1 ring-kyck-500'
                  : 'border-slate-300 bg-white text-slate-700 hover:border-slate-400',
              ].join(' ')}
            >
              <span className="block font-medium">{opt.label}</span>
              {opt.description && (
                <span className="mt-0.5 block text-xs text-slate-500">{opt.description}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
